module.exports = __webpack_public_path__ + "img/pine-watt-2Hzmz15wGik-unsplash.2251c6fc.jpg";